module.exports = {"pt-BR":{"realEstate":{"itemServiceField":{"label":"Serviço","notifications":{"fetch":{"failure":"Falha ao buscar serviços"}}}}}}